/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { UpdateOnboardingDraftResponse, UpdateOnboardingScheduleApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateOnboardingSchedule: build.mutation<UpdateOnboardingDraftResponse, UpdateOnboardingScheduleApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/onboarding/schedule`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateOnboardingScheduleApi };
export const { useUpdateOnboardingScheduleMutation } = injectedRtkApi;
